import { DynamicStandaloneRadioButton } from '@/components/RadioButton';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorRadioButton: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneRadioButton label={data.label} options={data.options} {...withDebugMetadata({ type, meta })} />
  );
};

export default LabradorRadioButton;
